import { Grid } from "@mui/material";
import { Icons } from "assets";
import styles from "./style.module.scss";
import StatsCard from "shared/components/statsCard";
import PendingPartnersGrid from "shared/components/projectHeadComponents/partners/pendingPartnersGrid";
import AccountsInFigure from "shared/components/projectHeadComponents/partners/accountsInFigure";
import PartnersListingsGrid from "shared/components/projectHeadComponents/partners/partnersListingsGrid";
import { useEffect, useState } from "react";
import useDebounce from "shared/customHooks/useDebounce";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";

function PhNewPartners() {
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [startDate, setStartDate] = useState<Date | null>(new Date());

  let statsCard = [
    {
      label: "Accounts Stats",
      count: 100,
      stats: {
        index: true,
        difference: "10%",
      },
    },
    {
      label: "Total Publishers",
      count: 50,
      stats: {
        index: false,
        difference: "2%",
      },
    },
    {
      label: "Pending MOUs",
      count: 1000,
      stats: {
        index: true,
        difference: "5%",
      },
    },
  ];

  useBreadcrumbs({
    title: "Partners",
    path: routeConstant?.partners?.path,
  });

  return (
    <div className={styles.mainContainer}>
      <HeadingContainer />
      <StatsCard
        statsList={statsCard}
        label={"Accounts Stats"}
        isDateRequired={true}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      <Grid container spacing={2}>
        <Grid xs={12} lg={9} item>
          <PendingPartnersGrid />
        </Grid>
        <Grid xs={12} lg={3} item>
          <AccountsInFigure />
        </Grid>
      </Grid>
      <PartnersListingsGrid />
    </div>
  );
}

export default PhNewPartners;

const HeadingContainer = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");

  useDebounce(
    () => {
      setSearchText(search.trim());
    },
    [search],
    800
  );

  useEffect(() => {
    if (searchText?.length) {
      navigate({
        pathname: routeConstant.partnerListings.path,
        search: `?text=${searchText}`,
      });
    }
    // eslint-disable-next-line
  }, [searchText]);

  return (
    <Grid container>
      <Grid xs={12} md={6} sx={{ display: "flex", alignItems: "center" }}>
        <span className={styles.heading}>Partners Accounts Stats</span>
      </Grid>
      <Grid xs={12} md={6}>
        <div className={styles.searchInputContainer}>
          <Icons.SearchIcon2 className={styles.searchIcon} />
          <input
            className={styles.seachInput}
            placeholder="Search author or publisher by name or publication house "
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </Grid>
    </Grid>
  );
};
